class Accordion {
  constructor() {
    this.initAccordion();
  }

  initAccordion() {
    let triggers = document.querySelectorAll(".accordion-trigger");
    let i;
    
    if (triggers) {
      for (i = 0; i < triggers.length; i++) {
        triggers[i].addEventListener("click", function() {
          this.classList.toggle("active");
          let panel = this.nextElementSibling;
          if (panel.style.maxHeight) {
            panel.style.maxHeight = null;
          } else {
            panel.style.maxHeight = panel.scrollHeight + "px";
          }
        });
      }
    }
  }
}

export default Accordion;